// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"268":"Home","313":"Details","419":"InfoCenter","797":"Iframe","842":"List","845":"LiveRoom"}[chunkId] || chunkId) + "." + {"268":"7e975c81","313":"fec230c4","419":"f891c4cf","440":"c7fcc620","492":"4378ee45","797":"76c875f3","842":"9a752593","845":"4e53cfec"}[chunkId] + ".js";
};